/**
 * @param {string} url - 需要校验的URL地址
 * @returns {boolean} - 返回true表示URL格式有效，false表示无效
 */
export const verifyUrl = (url) => {
  const reg = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/
  return reg.test(url)
};